import clsx from 'clsx'
import { ChevronRight } from '@/assets/icons'
import { type ExternalStorageProvider } from '@/constants/constants-external-storage'
import { PROVIDER_META } from '@/user_files/external-storage/ProviderMeta'

export default function ProviderOptionRow({
  providerKey,
  onSelect,
  disabled,
  comingSoon,
}: {
  providerKey: ExternalStorageProvider
  onSelect: () => void
  disabled?: boolean
  comingSoon?: boolean
}) {
  const meta = PROVIDER_META[providerKey]

  return (
    <button
      type="button"
      onClick={onSelect}
      disabled={disabled}
      className={clsx(
        'flex h-[54px] w-full items-center gap-3 border-t border-brand-neutral-200 bg-white pl-4 pr-4 text-left transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500',
        disabled ? 'cursor-not-allowed' : 'hover:bg-brand-neutral-50',
        comingSoon && 'text-brand-neutral-400',
        disabled && !comingSoon && 'opacity-50'
      )}
    >
      <span className={clsx('flex w-[33px] shrink-0 items-center justify-center', comingSoon && 'grayscale opacity-40')}>{meta.icon}</span>
      <span className={clsx('min-w-0 flex-1 text-sm leading-5 tracking-[-0.15px]', comingSoon ? 'text-brand-neutral-400' : 'text-brand-neutral-950')}>
        {meta.label}
      </span>
      {comingSoon && (
        <span className="shrink-0 rounded border border-brand-neutral-300 bg-brand-neutral-100 px-1.5 py-0.5 text-[9px] font-semibold uppercase leading-3 tracking-normal text-brand-neutral-950">
          Coming soon
        </span>
      )}
      {!comingSoon && (
        <span className="flex size-9 shrink-0 items-center justify-center" aria-hidden="true">
          <ChevronRight className="h-5 w-5 text-brand-neutral-600" />
        </span>
      )}
    </button>
  )
}
